import React, { useState } from 'react';
import PDFLogo from '../Media/pdf_logo.png'
import PreviewModal from 'Components/PreviewModal';
import Message from 'Components/Message';
import ToolTip from 'Components/ToolTip';
import { dateTimeFormat, formattooltip } from 'GenericForms/Helper';

type FileItem = {
    file_name: string | null;
    path: string;
    download_url: string;
    reporting_date_time_local: string;
    reporting_event: string;
    tabId: number;
};

type FileTableProps = {
    files: FileItem[];
    tabId: number;
};

const FileTable: React.FC<FileTableProps> = ({
    files,
    tabId
}) => {
    const [viewFileBool, setViewFileBool] = useState(false);
    const [selectedFile, setSelectedFile] = useState<FileItem>();
    const [hoverId, setHoverId] = useState<string | null>(null)

    return (
        <div>
            <div className='scroll-h25'>
                <table className="table mb-0">
                    <thead className="table-light">
                        <tr>
                            <th className="p-2 text-center sr-no-width">#</th>
                            <th className='p-2 text-start'>Event</th>
                            <th className="p-2">File Name</th>
                            <th className="p-2 text-center">Preview</th>
                            <th className="p-2 text-center">Date</th>
                            <th className="p-2 text-center">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        {files?.length > 0 ? (
                            files.map((file, index) => {
                                const fileName =
                                    file.file_name?.split('/').pop() ||
                                    file.path?.split('/').pop() ||
                                    'Unknown file';

                                const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(fileName);
                                const isPDF = /\.pdf$/i.test(fileName);

                                return (
                                    <tr key={index}>
                                        <td className="p-2 align-middle text-center">
                                            {index + 1}
                                        </td>
                                        <td className="p-2 align-middle ">
                                            {file.reporting_event}
                                        </td>
                                        <td className="p-2 align-middle">
                                            <div className="fw-medium text-truncate" style={{ maxWidth: 300 }}>
                                                {fileName}
                                            </div>
                                        </td>

                                        {/* Preview */}
                                        <td className="p-2 text-center align-middle">
                                            {isImage || isPDF ? (
                                                <img
                                                    src={isPDF ? PDFLogo : file.path}
                                                    alt="Preview"
                                                    id={`Click_Me_${index}_${tabId}`}
                                                    height="28"
                                                    className="pointer"
                                                    onMouseEnter={() => setHoverId(`Click_Me_${index}_${tabId}`)}
                                                    onMouseLeave={() => setHoverId(null)}
                                                    onClick={() => {
                                                        setSelectedFile(file);
                                                        setViewFileBool(true);
                                                        setHoverId(null);
                                                    }}
                                                />
                                            ) : (
                                                <span className="text-muted">N/A</span>
                                            )}
                                        </td>

                                        {/* Date */}
                                        <td className="p-2 text-center align-middle">
                                            {file.reporting_date_time_local
                                                ? dateTimeFormat(file.reporting_date_time_local)
                                                : '--'}
                                        </td>

                                        {/* Download */}
                                        <td className="p-2 text-center align-middle">
                                            <button
                                                type="button"
                                                className="btn btn-soft-primary btn-sm"
                                                id={`Download_File_${index}_${tabId}`}
                                                onMouseEnter={() => setHoverId(`Download_File_${index}_${tabId}`)}
                                                onMouseLeave={() => setHoverId(null)}
                                                onClick={() => {
                                                    window.location.href = file.download_url;
                                                    setHoverId(null);
                                                }}
                                            >
                                                <i className="dripicons-download font-size-14 align-middle" />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={6} className="p-3 text-center">
                                    <Message
                                        message="No files found"
                                        type="danger"
                                        width="25rem"
                                    />
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>
            {viewFileBool &&
                <PreviewModal
                    isOpen={viewFileBool}
                    toggle={() => setViewFileBool(false)}
                    file={selectedFile}
                />
            }
            {hoverId !== null && (
                <ToolTip
                    target={hoverId}
                    message={formattooltip(hoverId)}
                    isOpen={hoverId !== null}
                />
            )}
        </div>
    );
};

export default FileTable;
